import { useCallback } from 'react';
import { callScheduleRpc } from '../lib/scheduleRpc';

interface ExpandRecurringForYearResponse {
  success: boolean;
  year: number;
  expanded_count: number;
  businesses_processed: number;
}

export function useExpandRecurringForYear() {
  return useCallback(
    async (businessId: string, year: number) => {
      return callScheduleRpc<ExpandRecurringForYearResponse>(
        'expand_recurring_for_year',
        {
          p_business_id: businessId,
          p_year: year,
        },
      );
    },
    [],
  );
}
